import { Navigate, Outlet } from "react-router-dom";

import { useAuthStore } from "@/store/auth";

// Analityka przetargów ZE — technical director by default; CEO grants it to anyone else
// via has_ze_tender_analytics_access (Panel CEO). Mirrors backend CanAccessZETenderAnalytics.
export function ZETenderAnalyticsGuard() {
  const user = useAuthStore((s) => s.user);
  if (
    user?.is_ceo ||
    (user?.role === "director" && user?.is_technical_director) ||
    user?.has_ze_tender_analytics_access
  ) {
    return <Outlet />;
  }
  return <Navigate to="/" replace />;
}
